import { Environment } from '@shared/core';

export const environment: Environment = {
    BUGSNAG_KEY: '',
    RELEASE_STAGE: '',
    production: false,
    // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-var-requires
    VERSION: require('../../../../package.json').version,
    inMemory: false,
    api: {
        url: '',
    },
    contenthub: {
        token: '',
        url: '',
    },
    agora: {
        appId: '',
        logLevel: 0,
    },
    languageSettings: {
        languages: [
            {
                code: 'en',
                flag: 'assets/svg/flags/en.svg',
                localeId: 'en-x-source',
            },
            {
                code: 'sr',
                flag: 'assets/svg/flags/sr.svg',
                localeId: 'sr',
            },
        ],
    },
    reCaptcha: {
        v2: {
            siteKey: '',
            siteId: '',
        },
        v3: {
            siteKey: '',
            siteId: '',
        },
    },
};
